export enum ClinicEventType {
  Login = 'login',
  Heartbeat = 'heartbeat',
  AppointmentCreated = 'appointment_created',
  AppointmentCheckedIn = 'appointment_checked_in',
  AppointmentCheckedOut = 'appointment_checked_out',
  EncounterSigned = 'encounter_signed',
  VoiceToChartUsed = 'voice_to_chart_used',
  PcpInitialReportCreated = 'pcp_initial_report_created',
  PcpInterimReportCreated = 'pcp_interim_report_created',
  PcpReleaseReportCreated = 'pcp_release_report_created',
  CcsCompleted = 'ccs_completed',
  ConditionReferenceAccessed = 'condition_reference_accessed',
  ConditionReferenceEdited = 'condition_reference_edited',
  ClinicalEvaluationAccessed = 'clinical_evaluation_accessed',
  TreatmentTechniqueAccessed = 'treatment_technique_accessed',
  MarketingCampaignAccessed = 'marketing_campaign_accessed',
  FormsLibraryDownloaded = 'forms_library_downloaded',
  ResearchReviewAccessed = 'research_review_accessed',
  PatientCreated = 'patient_created',
  ConditionReportCreated = 'condition_report_created',
  ConditionReportSent = 'condition_report_sent',
  ExercisePlanCreated = 'exercise_plan_created',
  GoogleReviewLinkSent = 'google_review_link_sent',
  CcsSent = 'ccs_sent',
  ClinicLogoAdded = 'clinic_logo_added',
  FacebookLinked = 'facebook_linked',
  GoogleReviewUrlAdded = 'google_review_url_added',
  BillingInfoAdded = 'billing_info_added',
  CommercialNumbersAdded = 'commercial_numbers_added',
  FeatureSuggested = 'feature_suggested',
  FeatureVoted = 'feature_voted',
  KnowledgeBaseAccessed = 'knowledge_base_accessed',
  ConditionReportOpened = 'condition_report_opened',
  PostCareSurveyCompleted = 'post_care_survey_completed',
  PostCareSurveySent = 'post_care_survey_sent',
  HealthcomLogin = 'healthcom_login',
  PurchaseCreated = 'purchase_created',
  ClaimSent = 'claim_sent',
  ClaimAccepted = 'claim_accepted',
  PaymentCollected = 'payment_collected',
  EraUploaded = 'era_uploaded',
  NpiRejection = 'npi_rejection',
  EnrollmentRejection = 'enrollment_rejection',
  Format837Rejection = 'format_837_rejection',
  ProviderLoopError = 'provider_loop_error',
  ReferringProviderError = 'referring_provider_error',
  PlanChanged = 'plan_changed',
  UserRoleChanged = 'user_role_changed',
  UserRemovedFromClinic = 'user_removed_from_clinic',
  ClinicLocationAdded = 'clinic_location_added',
  ClinicScheduleUpdated = 'clinic_schedule_updated',
  UserAddedToClinic = 'user_added_to_clinic',
  ProviderBillingUpdated = 'provider_billing_updated',
  ProviderScheduleUpdated = 'provider_schedule_updated',
  SurveyPreferencesUpdated = 'survey_preferences_updated',
  SchedulingPreferencesUpdated = 'scheduling_preferences_updated',
  BillingGlobalSettingsUpdated = 'billing_global_settings_updated',
  ProviderSignatureAdded = 'provider_signature_added',
  ProviderSignatureDeleted = 'provider_signature_deleted',
  ProviderProfilePictureUpdated = 'provider_profile_picture_updated',
  OnlineSchedulingUrlUpdated = 'online_scheduling_url_updated',
  OnlineBookingsUserToggled = 'online_bookings_user_toggled',
  OnlineBookingTreatmentUpdated = 'online_booking_treatment_updated',
  PayorAdded = 'payor_added',
  BillingCodeAdded = 'billing_code_added',
  ModalityAdded = 'modality_added',
  SupplementAdded = 'supplement_added',
  HealthcareProviderAdded = 'healthcare_provider_added',
  TestAdded = 'test_added',
  NoShowCancelFeeAdded = 'no_show_cancel_fee_added',
  NoShowCancelFeeUpdated = 'no_show_cancel_fee_updated',
  PackageAdded = 'package_added',
  PackageUpdated = 'package_updated',
  DisciplineAdded = 'discipline_added',
  DisciplineUpdated = 'discipline_updated',
  KioskConnected = 'kiosk_connected',
  KioskDisconnected = 'kiosk_disconnected',
}
